import React from 'react'
import PropTypes from 'prop-types'

import './styles.css'

const Input = ({ label, placeholder, type, name, required }) => {
  const input = (
    <input
      className="h40 w-100 br2 ba b--moon-gray input-reset outline-0 pv2 ph3 sans-serif focus-b--green"
      type={type}
      name={name}
      placeholder={placeholder}
      required={required}
    />
  )

  if (label) {
    return (
      <label className="mb3">
        <span className="mb1 db">{label}</span>
        {input}
      </label>
    )
  }

  return input
}

Input.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool
}

export default Input



// WEBPACK FOOTER //
// ./src/components/input/input.js